import React from 'react';
import classNames from 'classnames';
const LinkButton = ({ tag, color, href, onClick, tabIndex, underline, children, className }) => {
    const Tag = href ? 'a' : tag;
    let linkAttributes;
    const extendedClassName = classNames('link', color ? `text-${color}` : '', {
        'link--underline': underline,
    }, {
        'link-reset': Tag === 'a',
    }, className);
    const attributes = { children, onClick, tabIndex, className: extendedClassName };
    if (href) {
        linkAttributes = Object.assign({ href }, attributes);
    }
    return <Tag {...(linkAttributes ? linkAttributes : attributes)}/>;
};
LinkButton.defaultProps = {
    tabIndex: 0,
    className: '',
    underline: false,
    tag: 'button',
};
export default LinkButton;
